import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import VueTranslate from 'vue-translate-plugin'
import locales from "./locales";
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import {  faCalendarCheck as farCalendarCheck, faHourglass as farHourglass} from '@fortawesome/free-regular-svg-icons'
import {
    faList, faStream, faCalendarCheck,  faChevronDown, faChevronUp, faChevronRight, faExternalLinkAlt, faSearchPlus, faSearchMinus,
    faLandmark, faRoute, faChalkboardTeacher, faGlasses, faEuroSign, faEdit, faGavel, faHourglassHalf, faArrowRight
} from '@fortawesome/free-solid-svg-icons'
library.add(
    faList, faStream, faCalendarCheck, farCalendarCheck, farHourglass, faChevronDown, faChevronUp, faChevronRight, faExternalLinkAlt, faSearchPlus,
    faSearchMinus, faLandmark, faRoute, faChalkboardTeacher, faGlasses, faEuroSign, faEdit, faGavel, faHourglassHalf, faArrowRight
);
Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.use(VueTranslate);
Vue.config.productionTip = false;

document.addEventListener("DOMContentLoaded", function() {
    document.querySelectorAll('.vue_mount--timeline:not([data-v-app])').forEach((e) => {
        const mountEl = e;
        const parentEl = mountEl.parentElement;

        new Vue({
            vuetify,
            locales,
            render: createElement => {
                const context = mountEl ?
                    {
                      props: { ...parentEl.dataset }
                    }
                    : {};
                return createElement(App, context);
            }
        }).$mount(mountEl);
    });
});